/* Copyright (c) 2022 Xperi. All Rights Reserved.  */

import {
    BrandingUiBundle,
    BrandingUiBundleApi,
    BrandingUiBundleGetRequest,
    Configuration,
    ConfigurationParameters,
} from 'client-code/branding-ui-bundle';
import { CommonHeaders } from '../CommonHeaders';
import { Constants } from '../constants';
import { DeviceFeatures } from '../device/DeviceFeatures';
import { DeviceModel } from '../device/DeviceModel';
import { IBrandingUIBundleServiceRepository } from '../interfaces/IBrandingUIBundleServiceRepository';
import { Log } from '../logging/Log';
import { TServicesParams } from '../types/TServicesParams';
import { UniqueIdentifier } from '../utils/UniqueIdentifier';
import { APPLICATION_FEATURE_AREA } from '../../config';

export class BrandingUIBundleServiceRepositoryImpl implements IBrandingUIBundleServiceRepository {
    mParams: TServicesParams;

    TAG: string = 'BrandingUIBundleServiceRepositoryImpl';

    private static brandingUiResponse: BrandingUiBundle = {};

    constructor(params: TServicesParams) {
        this.mParams = params;
    }

    private async getBrandingUiInfo(): Promise<BrandingUiBundle> {
        try {
            const commonHeaders = new CommonHeaders(APPLICATION_FEATURE_AREA.GUIDE).headers;
            const configurationParameters: ConfigurationParameters = {
                apiKey: this.mParams.accessToken,
                basePath: this.mParams.basePath,
                baseOptions: {
                    timeout: Constants.SERVICE_CONNECTION_TIMEOUT,
                    headers: commonHeaders,
                },
            };

            const requestParameters: BrandingUiBundleGetRequest = {
                msoPartnerId: DeviceModel.getTiVoSettings().getMsoPartnerId(),
                msoServiceId: DeviceFeatures.getMsoServiceId(),
                slsDomain: this.mParams.slsDomain,
                applicationFeatureArea: commonHeaders.ApplicationFeatureArea,
                applicationName: DeviceModel.getTiVoSettings().getAppName(),
                applicationVersion: DeviceModel.getAppVersionName(),
                deviceType: DeviceModel.getTiVoSettings().getDeviceType(),
                productName: DeviceModel.getTiVoSettings().getAppName(),
                originRequestId: UniqueIdentifier.generateOriginRequestId(),
            };
            const configuration = new Configuration(configurationParameters);
            const brandingUiService = new BrandingUiBundleApi(configuration);
            const brandingUiServiceResponse = await brandingUiService.brandingUiBundleGet(
                requestParameters,
            );
            BrandingUIBundleServiceRepositoryImpl.brandingUiResponse =
                brandingUiServiceResponse.data;

            return brandingUiServiceResponse.data;
        } catch (error) {
            Log.e(this.TAG, 'getBrandingUiInfo', error);
            throw error;
        }
    }

    /**
     *
     * @param key
     * @returns brandingUiInfo for required key
     */
    getBrandingUiInfoForKey = (key: string): any => {
        if (BrandingUIBundleServiceRepositoryImpl.brandingUiResponse[key])
            return BrandingUIBundleServiceRepositoryImpl.brandingUiResponse[key];
        throw Error('Key not found in Branding Ui response');
    };

    async getBrandingUiBundleInfo(): Promise<void> {
        try {
            await this.getBrandingUiInfo();
        } catch (error) {
            Log.e(this.TAG, 'getBrandingUiBundleInfo', error);
            throw error;
        }
    }
}
